mdApp.controller('Footer', ['$scope', '$element', function($scope, $element){
  var footerHeight = 100;
  $scope.toTop = function(e){
    TweenMax.to(document.body, 1, {
      scrollTop: 0,
      delay: 0,
      immediateRender: true
    });
  }
  $scope.showToTop = false;
  function updateToTop(e){
    if ((document.body.scrollHeight - (document.body.scrollTop + window.innerHeight)) < footerHeight-80 && !$scope.showToTop) {
      $scope.showToTop = true;
    }
    if ((document.body.scrollHeight - (document.body.scrollTop + window.innerHeight)) >= footerHeight-80 && $scope.showToTop) {
      $scope.showToTop = false;
    }
    $scope.$apply();
  }
  window.addEventListener('scroll', updateToTop);
  window.addEventListener('resize', updateToTop);
}]);